(() => {
  'use strict';

  const CLOSE_MS = 320;

  function getCollectionFilterDrawer() {
    return document.getElementById('GtCollectionFiltersDrawer');
  }

  function getCollectionFilterDetails() {
    return getCollectionFilterDrawer()?.querySelector('.mobile-facets__disclosure');
  }

  function getCollectionFilterSummary() {
    return getCollectionFilterDetails()?.querySelector('summary');
  }

  function isCollectionFilterDrawerOpen() {
    const details = getCollectionFilterDetails();
    return Boolean(details?.classList.contains('menu-opening') && details.hasAttribute('open'));
  }

  function expandCollectionFilterDetails() {
    const drawer = getCollectionFilterDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('.mobile-facets__main details.js-filter').forEach((details) => {
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    });
  }

  function setCollectionFilterDrawerOpen(shouldOpen) {
    const drawer = getCollectionFilterDrawer();
    const details = getCollectionFilterDetails();
    const summary = getCollectionFilterSummary();
    if (!drawer || !details || !summary) return;

    const breakpoint = drawer.dataset.breakpoint || 'mobile';

    if (shouldOpen) {
      if (details.gtCloseTimer) {
        window.clearTimeout(details.gtCloseTimer);
        details.gtCloseTimer = null;
      }

      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
      document.body.classList.add(`overflow-hidden-${breakpoint}`);
      expandCollectionFilterDetails();
      syncFilterTriggerExpanded();
      return;
    }

    if (!details.hasAttribute('open') && !details.classList.contains('menu-opening')) {
      syncFilterTriggerExpanded();
      return;
    }

    details.classList.remove('menu-opening');
    summary.setAttribute('aria-expanded', 'false');
    document.body.classList.remove(`overflow-hidden-${breakpoint}`);

    if (details.gtCloseTimer) window.clearTimeout(details.gtCloseTimer);
    details.gtCloseTimer = window.setTimeout(() => {
      details.removeAttribute('open');
      details.gtCloseTimer = null;
      expandCollectionFilterDetails();
      syncFilterTriggerExpanded();
    }, CLOSE_MS);
  }

  function openCollectionFilterDrawer() {
    setCollectionFilterDrawerOpen(true);
  }

  function closeCollectionFilterDrawer() {
    setCollectionFilterDrawerOpen(false);
  }

  function syncFilterTriggerExpanded() {
    const isOpen = isCollectionFilterDrawerOpen();

    document.querySelectorAll('[data-gt-collection-filter-open]').forEach((button) => {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /** Block Dawn MenuDrawer from toggling the GT drawer shell (filter AJAX re-binds summary). */
  function patchCollectionFilterDrawerMenuDrawer() {
    const drawer = getCollectionFilterDrawer();
    if (!drawer || drawer.dataset.gtMenuPatched === 'true') return;
    drawer.dataset.gtMenuPatched = 'true';

    const main = drawer.querySelector('.mobile-facets__disclosure');
    if (!main) return;

    main.addEventListener(
      'click',
      (event) => {
        const summary = event.target.closest('summary');
        if (!summary || summary.parentNode !== main) return;
        event.preventDefault();
        event.stopPropagation();
        if (isCollectionFilterDrawerOpen()) {
          closeCollectionFilterDrawer();
        } else {
          openCollectionFilterDrawer();
        }
      },
      true
    );

    drawer.openMenuDrawer = (summaryElement) => {
      openCollectionFilterDrawer();
      summaryElement?.setAttribute('aria-expanded', 'true');
    };

    drawer.closeMenuDrawer = (event) => {
      if (event === undefined) return;
      closeCollectionFilterDrawer();
    };
  }

  function portalFilterDrawerToBody() {
    const drawer = getCollectionFilterDrawer();
    if (!drawer || drawer.dataset.gtPortaled === 'true') return;
    document.body.appendChild(drawer);
    drawer.dataset.gtPortaled = 'true';
  }

  function bindFilterTriggers() {
    const drawer = getCollectionFilterDrawer();
    const details = getCollectionFilterDetails();
    if (!drawer || !details) return;

    if (details.dataset.gtCollectionFilterObserve !== 'true') {
      details.dataset.gtCollectionFilterObserve = 'true';
      const observer = new MutationObserver(syncFilterTriggerExpanded);
      observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    }

    if (drawer.dataset.gtCollectionFilterCloseDelegated !== 'true') {
      drawer.dataset.gtCollectionFilterCloseDelegated = 'true';
      drawer.addEventListener('click', (event) => {
        const closeTarget = event.target.closest(
          '[data-gt-collection-filter-close], .gt-collection-facets-drawer__overlay'
        );
        if (!closeTarget) return;
        event.preventDefault();
        closeCollectionFilterDrawer();
      });
    }

    syncFilterTriggerExpanded();
  }

  function bindFilterOpenDelegation() {
    if (document.documentElement.dataset.gtCollectionFilterOpenDelegated === 'true') return;
    document.documentElement.dataset.gtCollectionFilterOpenDelegated = 'true';

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-gt-collection-filter-open]');
      if (!button) return;
      event.preventDefault();
      openCollectionFilterDrawer();
    });
  }

  function init() {
    portalFilterDrawerToBody();
    patchCollectionFilterDrawerMenuDrawer();
    bindFilterOpenDelegation();
    bindFilterTriggers();
    expandCollectionFilterDetails();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('gt:facets:rendered', init);
})();
